module.exports = __webpack_public_path__ + "img/h54img4.6e70c4c0.png";